import { ReactNode, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useProfile } from "@/hooks/useProfile";

export const ProfileGate = ({ children }: { children: ReactNode }) => {
  const { profile, loading, refresh } = useProfile();
  const location = useLocation();
  const [handleRechecked, setHandleRechecked] = useState(false);
  const needsHandle = Boolean(profile?.quiz_completed_at && !profile?.username);
  const isHandleSetup = location.pathname.startsWith("/app/welcome");
  const handleJustSaved = Boolean(
    (location.state as { handleJustSaved?: boolean } | null)?.handleJustSaved,
  );

  useEffect(() => {
    setHandleRechecked(false);
  }, [location.pathname]);

  useEffect(() => {
    if (!needsHandle || isHandleSetup || !handleJustSaved || handleRechecked) return;
    let cancelled = false;
    refresh().finally(() => {
      if (!cancelled) setHandleRechecked(true);
    });
    return () => {
      cancelled = true;
    };
  }, [handleJustSaved, handleRechecked, isHandleSetup, needsHandle, refresh]);

  if (loading || (needsHandle && handleJustSaved && !handleRechecked)) {
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground">
        Loading…
      </div>
    );
  }
  if (!profile?.quiz_completed_at) return <Navigate to="/quiz" replace />;
  if (needsHandle && !isHandleSetup) {
    return <Navigate to="/app/welcome/handle" replace />;
  }
  return <>{children}</>;
};